export const SET_USER_LOCATION = 'cart/SET_USER_LOCATION'
export const SET_DELIVERY_TYPE = 'cart/SET_DELIVERY_TYPE'
export const SET_ORDER_DELIVERY_TYPE = 'cart/SET_ORDER_DELIVERY_TYPE'
export const SET_ORDER_POSTCODE = 'cart/SET_ORDER_POSTCODE'
export const SET_RESTAURANT = 'cart/SET_RESTAURANT'
export const ADD_TO_CART = 'cart/ADD_TO_CART'
export const REMOVE_FROM_CART = 'cart/REMOVE_FROM_CART'
export const INCREASE_ITEM_QUANTITY = 'cart/INCREASE_ITEM_QUANTITY'
export const DECREASE_ITEM_QUANTITY = 'cart/DECREASE_ITEM_QUANTITY'
export const UPDATE_CART_PRODUCT = 'cart/UPDATE_CART_PRODUCT'
export const CLEAR_CART = 'cart/CLEAR_CART'
export const UPDATE_SHOP = 'cart/UPDATE_SHOP'



// WEBPACK FOOTER //
// ./src/vuex/modules/cart/mutation-types.js